import {HeroCarouselFields} from "./types";

const fieldsMock: HeroCarouselFields = {
  "Show Carousel Overlay": { "value": true },
  
  "Carousel Slides": [
    {
      "fields": {
        "Text Color": {
          "fields": {
            "Key": {
              "value": "corporateBlack"
            }
          }
        },
        "Title": {
          "value": "THE FREEDOM TO FARM THE WAY YOU WANT."
        },
        "Content": {
          "value": "Discover the new, powerful, and efficient AFS Connect™ Steiger Series"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/dsk/hero-carousel-d-1.jpg",
            "alt": "Tiger-Mate 200 Field Cultivator Tiller",
            "width": "1680",
            "height": "760"
          }
        },
        "imageMobile": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/mobile/hero-carousel-m-1.jpg",
            "alt": "Tiger-Mate 200 Field Cultivator Tiller",
            "width": "384",
            "height": "785"
          }
        },
        "Link": {
          "value": {
            "href": "",
            "text": "EXPLORE",
            "url": "",
            "title": "Explore",
            "target": ""
          }
        },
        "Video": {
          value: {
            id: "{06986645-a76f-4f83-9f52-fede5004a7d2}",
            target: "",
            linktype: "media",
            href: "//localhost:8085/videos/HeroCarousel_0.mp4"
          }
        },
        "Use Video": {
          "value": false
        }
      }
    },
    {
      'fields': {
        'Text Color': {
          'fields': {
            'Key': {
              'value': 'corporateBlack'
            }
          }
        },
        'Title': {
          'value': 'THE FREEDOM TO FARM THE WAY YOU WANT.'
        },
        'Content': {
          'value': 'Discover the new, powerful, and efficient AFS Connect™ Steiger Series'
        },
        'Image': {
          'value': {
            'src': '',
            'alt': 'AFS Connect Steiger 470 and Speed Tiller 475',
            'width': '1680',
            'height': '760'
          }
        },
        'imageMobile': {
          'value': {
            'src': '',
            'alt': 'AFS Connect Steiger 470 and Speed Tiller 475',
            "width": "384",
            "height": "785"
          }
        },
        'Link': {
          'value': {
            'href': '',
            'text': 'EXPLORE',
            'url': '',
            'title': 'Explore',
            'target': ''
          }
        },
        'Video': {
          value: {
            href: '//localhost:8085/videos/HeroCarousel_0.mp4',
            linktype: 'media',
            target: '',
            id: '{DBE29166-0309-4F12-BC5F-B84F3E68BEA0}'
          }
        },
        'Use Video': {
          'value': false
        }
      }
    },
    {
      "fields": {
        "Text Color": {
          "fields": {
            "Key": {
              "value": "corporateBlack"
            }
          }
        },
        "Title": {
          "value": "THE FREEDOM TO FARM THE WAY YOU WANT."
        },
        "Content": {
          "value": "Discover the new, powerful, and efficient AFS Connect™ Steiger Series"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/dsk/hero-carousel-d-3.jpg",
            "alt": "AFS Connect Steiger 470 and Speed Tiller 475",
            "width": "1680",
            "height": "760"
          }
        },
        "imageMobile": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/mobile/hero-carousel-m-3.jpg",
            "alt": "Vestrum Series 130",
            "width": "384",
            "height": "785"
          }
        },
        "Link": {
          "value": {
            "href": "",
            "text": "EXPLORE",
            "url": "",
            "title": "Explore",
            "target": ""
          }
        },
        "Video": {
          value: {
            href: "//localhost:8085/videos/HeroCarousel_0.mp4",
            id: "{06986645-a76f-4f83-9f52-fede5004a7d2}",
            linktype: "media",
            target: ""
          }
        },
        "Use Video": {
          "value": false
        }
      }
    },
    {
      "fields": {
        "Text Color": {
          "fields": {
            "Key": {
              "value": "corporateBlack"
            }
          }
        },
        "Title": {
          "value": "THE FREEDOM TO FARM THE WAY YOU WANT."
        },
        "Content": {
          "value": "Discover the new, powerful, and efficient AFS Connect™ Steiger Series"
        },
        "Image": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/dsk/hero-carousel-d-4.jpg",
            "alt": "AFS Connect Steiger 470 and Speed Tiller 475",
            "width": "1680",
            "height": "760"
          }
        },
        "imageMobile": {
          "value": {
            "src": "//localhost:8085/images/hero-carousel/mobile/hero-carousel-m-4.jpg",
            "alt": "AFS Connect Steiger 470 and Speed Tiller 475",
            "width": "384",
            "height": "785"
          }
        },
        "Link": {
          "value": {
            "href": "",
            "text": "EXPLORE",
            "url": "",
            "title": "Explore",
            "target": ""
          }
        },
        "Video": {
          value: {
            href: "//localhost:8085/videos/HeroCarousel_0.mp4",
            id: "{06986645-a76f-4f83-9f52-fede5004a7d2}",
            linktype: "media",
            target: ""
          }
        },
        "Use Video": {
          "value": true
        }
      }
    }
  ],
  "params":{},
}

export default fieldsMock;
